import React from 'react';
import EditProfile from '../features/profile';

const EditProfilePage = () => {
  return <EditProfile />;
};

export default EditProfilePage;
